import {
  IKnmErknmFormViolatedRequirementsMandatory,
  IKnmErknmFormViolatedRequirementsNpa,
} from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmFormViolatedRequirementsNpa';
import { IKnmErknmFormViolation } from 'KnmErknmPackage/ErknmViolationsModule/interfaces/IKnmErknmFormViolation';
import { ViolationStatusesEnum } from 'APIPackage/KnmModule/enums/ViolationStatusesEnum';

export function getRequirementsWithNonFixedViolations(
  items: IKnmErknmFormViolatedRequirementsNpa[],
): IKnmErknmFormViolatedRequirementsNpa[] {
  const requirementsWithNonFixedViolations: IKnmErknmFormViolatedRequirementsNpa[] = [];

  items.forEach(requirement => {
    const mandatoriesWithNonFixedViolations: IKnmErknmFormViolatedRequirementsMandatory[] = [];

    requirement.violatedMandatory.forEach(mandatory => {
      const nonFixedViolations: IKnmErknmFormViolation[] = [];

      mandatory.violations?.forEach(violation => {
        if (violation.status === ViolationStatusesEnum.NOT_FIXED) {
          nonFixedViolations.push({ ...violation, isNew: true });
        }
      });

      if (nonFixedViolations.length) {
        mandatoriesWithNonFixedViolations.push({
          ...mandatory,
          violations: nonFixedViolations,
        });
      }
    });

    if (mandatoriesWithNonFixedViolations.length) {
      requirementsWithNonFixedViolations.push({
        ...requirement,
        violatedMandatory: mandatoriesWithNonFixedViolations,
      });
    }
  });

  return requirementsWithNonFixedViolations;
}
